export default "__VITE_ASSET__DEI_oUdC__"